import { render, staticRenderFns } from "./RDropdownMultiSelect.vue?vue&type=template&id=64672d5b&scoped=true&"
import script from "./RDropdownMultiSelect.vue?vue&type=script&lang=js&"
export * from "./RDropdownMultiSelect.vue?vue&type=script&lang=js&"
import style0 from "./RDropdownMultiSelect.vue?vue&type=style&index=0&id=64672d5b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64672d5b",
  null
  
)

export default component.exports